// Top-up currencies, limits and bank requisites
export const TOPUP_CURRENCIES = ['USD', 'KGS', 'EUR', 'MDL', 'KZT', 'RUB'];

export const TOPUP_CONFIG = {
  USD: { flag: '🇺🇸', fee: 1.0, min: 10, quick: [50, 100, 200, 500, 1000], mode: 'bank' },
  KGS: { flag: '🇰🇬', fee: 1.5, min: 500, quick: [5000, 10000, 20000, 50000, 100000], mode: 'bank' },
  EUR: { flag: '🇪🇺', fee: 1.0, min: 10, quick: [50, 100, 200, 500, 1000], mode: 'request', methods: ['SEPA'] },
  MDL: { flag: '🇲🇩', fee: 1.0, min: 100, quick: [500, 1000, 2000, 5000, 10000], mode: 'mia' },
  KZT: { flag: '🇰🇿', fee: 1.5, min: 5000, quick: [10000, 25000, 50000, 100000, 250000], mode: 'request', methods: ['KASPI', 'BANK'] },
  RUB: { flag: '🇷🇺', fee: 1.5, min: 1000, quick: [1000, 3000, 5000, 10000, 30000], mode: 'request', methods: ['SBP', 'MIR'], captcha: true },
};

export const METHOD_LABELS = {
  SBP: { ru: 'СБП (по номеру телефона)', en: 'SBP (Faster Payments)' },
  MIR: { ru: 'Карта МИР', en: 'MIR card' },
  SEPA: { ru: 'SEPA перевод', en: 'SEPA transfer' },
  KASPI: { ru: 'Kaspi перевод', en: 'Kaspi transfer' },
  BANK: { ru: 'Банковский перевод', en: 'Bank transfer' },
};

const AIYL_BANK = {
  bank: 'ОАО «Айыл Банк»',
  account: '1350100020221904',
  bik: '135001',
  recipient: 'ОсОО «ФВА Финанс»',
  inn: '01111201510129',
};

export const BANK_DETAILS = { USD: AIYL_BANK, KGS: AIYL_BANK };
